import React from 'react';

function Contact(){
  return (
    <p>Contact</p>
  )
}

export default Contact;